'use client';

import { useToast } from '@common/hooks';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { DONATION_ROUTES, STORAGE_KEY } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

const InquiryLayout = ({ children }: { children: React.ReactNode }) => {
  const router = useCustomRouter();
  const pathname = usePathname();
  const { toast } = useToast();

  const isHistoryPage =
    pathname === DONATION_ROUTES.MY_INQUIRY_HISTORY.pathname;

  useEffect(() => {
    if (isHistoryPage) return;

    const isDonationInquiryByGiftProduct =
      sessionStorage.getItem(
        STORAGE_KEY.IS_DONATION_INQUIRY_BY_GIFT_PRODUCT,
      ) === 'true';
    if (isDonationInquiryByGiftProduct) return;

    toast({ message: '채널톡으로 문의해주세요', type: 'info' });
    router.replace(DONATION_ROUTES.HOME.pathname);
  }, [router, toast, isHistoryPage]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem(
        STORAGE_KEY.IS_DONATION_INQUIRY_BY_GIFT_PRODUCT,
      );
    };
  }, []);

  return children;
};

export default InquiryLayout;
